export default __webpack_public_path__ + "static/media/salt.fdb0d152.jpg";